import Header from "./Header";
import Footer from "./Footer";
import CookieBanner from "../CookieBanner";
import { Outlet } from "react-router-dom";

import { Helmet } from "react-helmet-async";

export default function Layout() {
  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "Organization",
              "name": "Alfasol",
              "url": "https://alfasol.es",
              "email": "contacto@alfasol.com",
              "description": "Soluciones energéticas sostenibles basadas en biomasa"
            }
          `}
        </script>
      </Helmet>

      <Header />

      <main className="page-content">
        <Outlet />
      </main>

      <Footer />
      <CookieBanner />
    </>
  );
}